import { render } from "./LineChart2.vue?vue&type=template&id=63e6c04c"
import script from "./LineChart2.vue?vue&type=script&lang=js"
export * from "./LineChart2.vue?vue&type=script&lang=js"
script.render = render

export default script